import Orders from './index';
import Show from './show';
import Edit from './edit';

export default [
  {
    path: 'orders',
    name: 'orders.index',
    component: Orders,
    props: {
      resource: 'orders'
    },
    meta: {
      title: '购买订单',
      navbar: 'el-icon-tickets',
      permission: 'orders.read'
    },
  },
  {
    path: 'orders/:id',
    name: 'orders.show',
    component: Show,
    props: {
      resource: 'orders'
    },
    meta: {
      title: '订单详情',
      permission: 'orders.read'
    },
  },
  {
    path: 'orders/:id/edit',
    name: 'orders.edit',
    component: Edit,
    props: {
      resource: 'orders'
    },
    meta: {
      title: '编辑订单',
      permission: 'orders.update'
    },
  },
]
